import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { AuthContext } from "../../../contexts/AuthContext";
import { tempUrl } from "../../../contexts/ContextProvider";
import { ShowTablePenjualanChildSaved } from "../../../components/ShowTable";
import { Colors } from "../../../constants/styles";
import { Loader, SearchBar } from "../../../components";
import { addDays, diffDays, getShiftCode } from "../../../constants/helper";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Typography,
  Dialog,
  DialogTitle,
  DialogActions,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Autocomplete,
  TextField,
  Paper,
  Pagination,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import DatePicker from "react-datepicker";
import { makeStyles } from "@mui/styles";
import SaveIcon from "@mui/icons-material/Save";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SearchIcon from "@mui/icons-material/Search";
import { NumericFormat } from "react-number-format";
import useScreenWidth from "../../../hooks/useScreenWidth";

const useStyles = makeStyles({
  root: {
    "& .MuiTableCell-head": {
      color: "white",
      backgroundColor: Colors.blue700,
    },
  },
  tableRightBorder: {
    borderWidth: 0,
    borderRightWidth: 1,
    borderColor: "white",
    borderStyle: "solid",
  },
});

const TambahPenjualan = () => {
  const screenSize = useScreenWidth();
  const { user, setting, dispatch } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isPenjualanSaved, setIsPenjualanSaved] = useState(false);
  const [isCustomerChosen, setIsCustomerChosen] = useState(false);
  const [isCustomerTunaiChosen, setIsCustomerTunaiChosen] = useState(false);
  const [isCustomerGrosirChosen, setIsCustomerGrosirChosen] = useState(false);
  const [isInputStok, setIsInputStok] = useState(false);
  const [penjualanId, setPenjualanId] = useState(null);

  // Data Penjualan
  const [noNotaPenjualan, setNoNotaPenjualan] = useState("");
  let tempTglPenjualan = new Date();
  if (tempTglPenjualan > new Date(user.tutupperiode.sampaiTanggal)) {
    tempTglPenjualan = new Date(user.tutupperiode.dariTanggal);
  }
  const [tglPenjualan, setTglPenjualan] = useState(tempTglPenjualan);
  const [userIdKasir, setUserIdKasir] = useState(user.id);
  const [usernameKasir, setUsernameKasir] = useState(user.username);
  const [shiftPenjualan, setShiftPenjualan] = useState(
    getShiftCode(setting.batasShift)
  );
  const [jumlahItem, setJumlahItem] = useState("0");

  // Data Customer
  const [isGrosir, setIsGrosir] = useState("RETAIL");
  const [isCustomerBaru, setIsCustomerBaru] = useState(false);
  const [nopolCustomer, setNopolCustomer] = useState("");
  const [sumberCustomer, setSumberCustomer] = useState("EKSTERNAL");
  const [namaCustomer, setNamaCustomer] = useState("");
  const [noTeleponCustomer, setNoTeleponCustomer] = useState("");
  const [kodeMekanik, setKodeMekanik] = useState("");

  // Data Total
  const [subtotal, setSubtotal] = useState("0");
  const [kodeJenisPembayaran, setKodeJenisPembayaran] = useState("");
  const [potongan, setPotongan] = useState("0");
  const [biayaJenisPembayaran, setBiayaJenisPembayaran] = useState("0");
  const [totalBiaya, setTotalBiaya] = useState("0");
  const [total, setTotal] = useState("0");
  const [bayar, setBayar] = useState("0");
  const [kembali, setKembali] = useState("0");

  // Data Penjualan Kredit
  const [tipePenjualan, setTipePenjualan] = useState("TUNAI");
  const [lamaKredit, setLamaKredit] = useState("");
  const [tglJatuhTempo, setTglJatuhTempo] = useState(null);

  // Data Penjualan Child
  const [pilihStok, setPilihStok] = useState("");
  const [kodeStok, setKodeStok] = useState("");
  const [namaStok, setNamaStok] = useState("");
  const [quantity, setQuantity] = useState("0");
  const [hargaJual, setHargaJual] = useState("0");
  const [hargaJualRataRataStok, setHargaJualRataRataStok] = useState("0");
  const [discountPersen, setDiscountPersen] = useState("0");
  const [discount, setDiscount] = useState("0");
  const [hargaNetto, setHargaNetto] = useState("0");
  const [totalPenjualanChild, setTotalPenjualanChild] = useState("0");

  const [penjualanChilds, setPenjualanChilds] = useState([]);

  const [mekaniks, setMekaniks] = useState([]);
  const [jenisPembayarans, setJenisPembayarans] = useState([]);
  const [error, setError] = useState(false);

  const [customers, setCustomers] = useState([]);
  const [searchTermCustomer, setSearchTermCustomer] = useState("");
  const [openCustomer, setOpenCustomer] = useState(false);

  let [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [pages, setPages] = useState(0);
  const [rows, setRows] = useState(0);
  const [query, setQuery] = useState("");

  const [stoks, setStoks] = useState([]);
  const [searchTermStok, setSearchTermStok] = useState("");
  const [openStok, setOpenStok] = useState(false);

  let [pageStok, setPageStok] = useState(0);
  const [limitStok, setLimitStok] = useState(10);
  const [pagesStok, setPagesStok] = useState(0);
  const [rowsStok, setRowsStok] = useState(0);
  const [queryStok, setQueryStok] = useState("");

  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const handleChangeIsGrosir = (event) => {
    setIsGrosir(event.target.value);
    setIsCustomerBaru(false);

    if (event.target.value === "GROSIR") {
      setSumberCustomer("EKSTERNAL");
      setIsCustomerGrosirChosen(true);
      setKodeMekanik("");
    } else {
      setIsCustomerGrosirChosen(false);
      setTipePenjualan("TUNAI");
      setLamaKredit("");
      setTglJatuhTempo(null);
    }

    // Remove all prior inputs
    setNopolCustomer("");
    setNamaCustomer("");
    setNoTeleponCustomer("");
    setIsCustomerChosen(false);
    setIsCustomerTunaiChosen(false);
  };

  const classes = useStyles();

  const handleChange = (e, p) => {
    setPage(p - 1);
  };

  const searchData = (e) => {
    e.preventDefault();
    setPage(0);
    setSearchTermCustomer(query);
  };

  const handleClickOpenCustomer = () => {
    setOpenCustomer(true);
  };

  const handleCloseCustomer = () => {
    setOpenCustomer(false);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleChangeStok = (e, p) => {
    setPageStok(p - 1);
  };

  const searchDataStok = (e) => {
    e.preventDefault();
    setPageStok(0);
    setSearchTermStok(queryStok);
  };

  const handleClickOpenStok = () => {
    setOpenStok(true);
  };

  const handleCloseStok = () => {
    setOpenStok(false);
  };

  const sumberCustomerOption = ["INTERNAL", "EKSTERNAL"];
  const tipePenjualanOption = ["TUNAI", "KREDIT"];
  let mekanikOptions = mekaniks.map((mekanik) => ({
    label: `${mekanik.kodeMekanik} - ${mekanik.namaMekanik}`,
  }));
  let jenisPembayaranOptions = jenisPembayarans.map((jenisPembayaran) => ({
    label: `${jenisPembayaran.kodeJenisPembayaran} - ${jenisPembayaran.namaJenisPembayaran}`,
    biayaJenisPembayaran: jenisPembayaran.biayaJenisPembayaran,
  }));

  useEffect(() => {
    getPenjualanById();
    getMekaniks();
    getJenisPembayarans();
    findDefaultDate();
    getNextKodePenjualan(tempTglPenjualan);
  }, []);

  useEffect(() => {
    getCustomersData();
  }, [isGrosir, page, searchTermCustomer]);

  useEffect(() => {
    getStoksData();
  }, [pageStok, searchTermStok]);

  const getPenjualanById = async () => {
    if (id) {
      setIsCustomerChosen(true);
      setIsPenjualanSaved(true);
      setIsInputStok(true);
      setPenjualanId(id);
      const response = await axios.post(`${tempUrl}/penjualans/${id}`, {
        kodeCabang: user.cabang.id,
        _id: user.id,
        token: user.token,
      });
      // Data Penjualan
      setNoNotaPenjualan(response.data.noNotaPenjualan);
      setTglPenjualan(new Date(response.data.tglPenjualan));
      setUserIdKasir(response.data.user.id);
      setUsernameKasir(response.data.user.username);
      setShiftPenjualan(response.data.shiftPenjualan);

      // Data Customer
      setNopolCustomer(response.data.nopolCustomer);
      setSumberCustomer(response.data.sumberCustomer);
      setNamaCustomer(response.data.namaCustomer);
      setNoTeleponCustomer(response.data.noTeleponCustomer);
      setKodeMekanik(
        response.data.mekanik && response.data.mekanik.namaMekanik
      );

      // Data Total
      setSubtotal(response.data.subtotal);
      setKodeJenisPembayaran(
        response.data.jenispembayaran &&
          `${response.data.jenispembayaran.kodeJenisPembayaran} - ${response.data.jenispembayaran.namaJenisPembayaran}`
      );
      setPotongan(response.data.potongan);
      setBiayaJenisPembayaran(response.data.biayaJenisPembayaran);
      setTotalBiaya(response.data.totalBiaya);
      setTotal(response.data.total);
      setBayar(response.data.bayar);
      setKembali(response.data.kembali);

      // Data Penjualan Kredit
      setTipePenjualan(response.data.tipePenjualan);
      setLamaKredit(response.data.lamaKredit);
      setTglJatuhTempo(
        response.data.tglJatuhTempo
          ? new Date(response.data.tglJatuhTempo)
          : null
      );

      const response2 = await axios.post(
        `${tempUrl}/penjualanChildsByPenjualan`,
        {
          penjualanId: response.data.id,
          kodeCabang: user.cabang.id,
          _id: user.id,
          token: user.token,
        }
      );
      setPenjualanChilds(response2.data);
      setJumlahItem(response2.data.length);
    }
  };

  const getMekaniks = async () => {
    const response = await axios.post(`${tempUrl}/mekaniks`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setMekaniks(response.data);
  };

  const getJenisPembayarans = async () => {
    const response = await axios.post(`${tempUrl}/jenisPembayarans`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setJenisPembayarans(response.data);
  };

  const findDefaultDate = async () => {
    let newPeriodeAwal = new Date(user.tutupperiode.dariTanggal);
    let newPeriodeAkhir = new Date(user.tutupperiode.sampaiTanggal);
    let newToday = new Date();

    let isDateBetween =
      newToday >= newPeriodeAwal && newToday <= newPeriodeAkhir;

    if (isDateBetween) {
      // Default Date Today
      setTglPenjualan(new Date());
    }
  };

  const getNextKodePenjualan = async (date) => {
    const nextKodePenjualan = await axios.post(
      `${tempUrl}/penjualansNextKode`,
      {
        dariTanggal: user.tutupperiode.dariTanggal,
        sampaiTanggal: user.tutupperiode.sampaiTanggal,
        tglPenjualan: date,
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    setNoNotaPenjualan(nextKodePenjualan.data);
  };

  const getCustomersData = async () => {
    if (isGrosir === "RETAIL") {
      const response = await axios.post(
        `${tempUrl}/customersPerCabangRetailPagination?search_query=${searchTermCustomer}&page=${page}&limit=${limit}`,
        {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      setCustomers(response.data.customers);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    } else {
      const response = await axios.post(
        `${tempUrl}/customersPerCabangGrosirPagination?search_query=${searchTermCustomer}&page=${page}&limit=${limit}`,
        {
          _id: user.id,
          token: user.token,
          kodeCabang: user.cabang.id,
        }
      );
      setCustomers(response.data.customers);
      setPage(response.data.page);
      setPages(response.data.totalPage);
      setRows(response.data.totalRows);
    }
  };

  const getCustomerNextKode = async () => {
    const response = await axios.post(`${tempUrl}/customerNextKode`, {
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setNopolCustomer(response.data);
  };

  const getStoksData = async () => {
    const response = await axios.post(
      `${tempUrl}/stoksPagination?search_query=${searchTermStok}&page=${pageStok}&limit=${limitStok}`,
      {
        _id: user.id,
        token: user.token,
        kodeCabang: user.cabang.id,
      }
    );
    setStoks(response.data.stoks);
    setPageStok(response.data.page);
    setPagesStok(response.data.totalPage);
    setRowsStok(response.data.totalRows);
  };

  const getFindStok = async (input) => {
    setHargaJualRataRataStok("0");

    const response = await axios.post(`${tempUrl}/findStok`, {
      input,
      _id: user.id,
      token: user.token,
      kodeCabang: user.cabang.id,
    });
    setKodeStok(response.data.kodeStok);
    setNamaStok(response.data.namaStok);
    setHargaJual(response.data.hargaJualStok);
    setHargaJualRataRataStok(response.data.hargaJualRataRataStok || 0);
    setHargaNetto(response.data.hargaJualStok);
    setTotalPenjualanChild(response.data.hargaJualStok);
  };

  const savePenjualan = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    if (penjualanId !== null) {
      setIsInputStok(true);
      setDiscountPersen("0");
      setDiscount("0");
      return;
    }

    if (form.checkValidity() && nopolCustomer.length !== 0) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedPenjualan = await axios.post(`${tempUrl}/savePenjualan`, {
          dariTanggal: user.tutupperiode.dariTanggal,
          sampaiTanggal: user.tutupperiode.sampaiTanggal,

          // Data Penjualan
          tglPenjualan,
          userIdKasir,
          shiftPenjualan,

          // Data Customer
          isGrosir,
          isCustomerBaru,
          nopolCustomer,
          sumberCustomer,
          namaCustomer,
          noTeleponCustomer,
          kodeMekanik: kodeMekanik.split(" ", 1)[0],

          // Total
          subtotal,
          kodeJenisPembayaran: null,
          potongan,
          biayaJenisPembayaran,
          totalBiaya,
          total,
          bayar,
          kembali,

          // Data Penjualan Kredit
          tipePenjualan,
          lamaKredit,
          tglJatuhTempo,

          userIdInput: user.id,
          kodeCabang: user.cabang.id,
          _id: user.id,
          token: user.token,
        });
        setIsCustomerChosen(true);
        setIsPenjualanSaved(true);
        setIsInputStok(true);
        // setLoading(false);
        setPenjualanId(savedPenjualan.data.id);
        navigate(
          `/daftarPenjualan/penjualan/tambahPenjualan/${savedPenjualan.data.id}`
        );
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const savePenjualanChild = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;
    if (
      form.checkValidity() &&
      kodeStok.length !== 0 &&
      quantity.length !== 0 &&
      discountPersen.length !== 0 &&
      discount.length !== 0
    ) {
      // setLoading(true);
      try {
        // setLoading(true);
        let savedPenjualanChild = await axios.post(
          `${tempUrl}/savePenjualanChild`,
          {
            // Data Penjualan Child
            penjualanId,
            kodeStok,
            namaStok,
            quantity,
            hargaJual,
            discountPersen,
            discount,
            hargaNetto,
            totalPenjualanChild,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        setIsInputStok(false);

        // Data Penjualan Child
        setPilihStok("");
        setKodeStok("");
        setNamaStok("");
        setQuantity("");
        setHargaJual("");
        setHargaJualRataRataStok("0");
        setDiscountPersen("");
        setDiscount("");
        setHargaNetto("");
        setTotalPenjualanChild("");

        let findPenjualanChild = await axios.post(
          `${tempUrl}/penjualanChildsByPenjualan`,
          {
            penjualanId,
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setPenjualanChilds(findPenjualanChild.data);
        setJumlahItem(findPenjualanChild.data.length);

        let findPenjualan = await axios.post(
          `${tempUrl}/penjualans/${penjualanId}`,
          {
            _id: user.id,
            token: user.token,
            kodeCabang: user.cabang.id,
          }
        );
        setSubtotal(findPenjualan.data.subtotal);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  const savePenjualanTotal = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    let tempValidation =
      form.checkValidity() && kodeJenisPembayaran.length !== 0;

    if (tipePenjualan === "KREDIT") {
      tempValidation =
        form.checkValidity() &&
        kodeJenisPembayaran.length !== 0 &&
        lamaKredit.length !== 0 &&
        tglJatuhTempo !== null;
    }

    if (tempValidation) {
      // setLoading(true);
      try {
        // setLoading(true);
        let updatedPenjualan = await axios.post(
          `${tempUrl}/updatePenjualanTotal/${penjualanId}`,
          {
            tglPenjualan,
            // Total
            subtotal,
            kodeJenisPembayaran: kodeJenisPembayaran.split(" ", 1)[0],
            potongan,
            biayaJenisPembayaran,
            totalBiaya,
            total,
            bayar,
            kembali,

            // Data Penjualan Kredit
            tipePenjualan,
            lamaKredit,
            tglJatuhTempo,

            userIdInput: user.id,
            kodeCabang: user.cabang.id,
            _id: user.id,
            token: user.token,
          }
        );
        navigate(`/daftarPenjualan/penjualan/${penjualanId}`);
      } catch (error) {
        alert(error.response.data.message);
      }
      // setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Tambah Penjualan</h5>
      <Typography sx={subTitleText}>
        Periode : {user.tutupperiode.namaPeriode}
      </Typography>
      <hr />
      <Form noValidate validated={validated} onSubmit={savePenjualan}>
        <Card>
          <Card.Header>Data Penjualan</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Nota :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={noNotaPenjualan}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tanggal{" "}
                        {isPenjualanSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          required
                          dateFormat="dd/MM/yyyy"
                          selected={tglPenjualan}
                          minDate={new Date(user.tutupperiode.dariTanggal)}
                          maxDate={new Date(user.tutupperiode.sampaiTanggal)}
                          customInput={<Form.Control required />}
                          onChange={(date) => {
                            setTglPenjualan(date);
                            getNextKodePenjualan(date);
                          }}
                          disabled={isPenjualanSaved && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kasir :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={usernameKasir}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Shift :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={shiftPenjualan}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jumlah Item :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={jumlahItem}
                          disabled
                          readOnly
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>
          </Card.Body>
        </Card>

        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Customer</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tipe Customer :
                      </Form.Label>
                      <Col sm="7">
                        <RadioGroup
                          row
                          aria-labelledby="demo-controlled-radio-buttons-group"
                          name="controlled-radio-buttons-group"
                          defaultValue="RETAIL"
                          value={isGrosir}
                          onChange={handleChangeIsGrosir}
                        >
                          <FormControlLabel
                            value="RETAIL"
                            control={<Radio />}
                            label="Retail"
                            disabled={isPenjualanSaved && true}
                          />
                          <FormControlLabel
                            value="GROSIR"
                            control={<Radio />}
                            label="Grosir"
                            disabled={isPenjualanSaved && true}
                          />
                        </RadioGroup>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Customer Baru :
                      </Form.Label>
                      <Col sm="7">
                        <FormControlLabel
                          control={<Checkbox checked={isCustomerBaru} />}
                          onChange={() => {
                            setIsCustomerBaru(!isCustomerBaru);

                            if (
                              !isCustomerBaru === true &&
                              isGrosir === "GROSIR"
                            ) {
                              getCustomerNextKode();
                            } else {
                              setNopolCustomer("");
                            }

                            if (!isCustomerBaru === true) {
                              setIsCustomerBaru(true);
                            }

                            // Empty Customer
                            setNopolCustomer("");
                            setNamaCustomer("");
                            setNoTeleponCustomer("");
                            setIsCustomerChosen(false);
                            setIsCustomerTunaiChosen(false);
                          }}
                          disabled={isPenjualanSaved && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. Polisi{" "}
                        {isPenjualanSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          required
                          value={nopolCustomer}
                          onChange={(e) => {
                            setNopolCustomer(e.target.value);
                            if (e.target.value.toUpperCase() == "TUNAI") {
                              setNamaCustomer("PENJUALAN TUNAI");
                              setIsCustomerChosen(true);
                            }
                          }}
                          style={{ textTransform: "uppercase" }}
                          disabled={
                            isPenjualanSaved === true ||
                            isGrosir === "GROSIR" ||
                            isCustomerBaru === false
                          }
                        />
                      </Col>
                      <Col sm="2">
                        <Button
                          variant="contained"
                          onClick={() => handleClickOpenCustomer()}
                          disabled={isPenjualanSaved && true}
                        >
                          <SearchIcon />
                        </Button>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Sumber{" "}
                        {isPenjualanSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={sumberCustomer}
                          onChange={(e) => {
                            setSumberCustomer(e.target.value);
                          }}
                          disabled={isPenjualanSaved && true}
                        >
                          {sumberCustomerOption.map((sumberCustomer) => (
                            <option value={sumberCustomer}>
                              {sumberCustomer}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama{" "}
                        {isPenjualanSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={namaCustomer}
                          onChange={(e) => {
                            setNamaCustomer(e.target.value);
                          }}
                          style={{ textTransform: "uppercase" }}
                          disabled={isCustomerChosen && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        No. HP{" "}
                        {isPenjualanSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control
                          required
                          value={noTeleponCustomer}
                          onChange={(e) => {
                            setNoTeleponCustomer(e.target.value);
                          }}
                          style={{ textTransform: "uppercase" }}
                          disabled={isCustomerChosen && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Mekanik{" "}
                        {isPenjualanSaved === false ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={mekanikOptions}
                          renderInput={(params) => (
                            <TextField
                              error={error && kodeMekanik.length === 0 && true}
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setKodeMekanik(value.label);
                            } else {
                              setKodeMekanik("");
                            }
                          }}
                          value={kodeMekanik}
                          disabled={
                            isPenjualanSaved ||
                            isCustomerTunaiChosen ||
                            (isCustomerGrosirChosen && true)
                          }
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="contained"
            color="info"
            sx={{
              bgcolor: "info.light",
              textTransform: "none",
              marginRight: 2,
              marginBottom: 2,
            }}
            type="submit"
          >
            {"+ Input Transaksi"}
          </Button>
        </Box>
      </Form>

      <Form noValidate validated={validated} onSubmit={savePenjualanChild}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Detail Transaksi</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kode / Barcode{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="5">
                        <Form.Control
                          required
                          value={pilihStok}
                          onChange={(e) => {
                            setPilihStok(e.target.value);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              // alert("Enter pressed on kodeStok");
                              getFindStok(e.target.value);
                            }
                          }}
                          style={{ textTransform: "uppercase" }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="2">
                        <Button
                          variant="contained"
                          onClick={() => handleClickOpenStok()}
                          disabled={isInputStok === true ? false : true}
                        >
                          <SearchIcon />
                        </Button>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Nama Stok :
                      </Form.Label>
                      <Col sm="7">
                        <Form.Control disabled value={namaStok} />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Quantity{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={quantity}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setQuantity(tempValue);

                            let tempTotalPenjualanChild =
                              parseFloat(tempValue) * parseFloat(hargaNetto);
                            setTotalPenjualanChild(tempTotalPenjualanChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Jual Rata-Rata :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          value={hargaJualRataRataStok}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          disabled
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Jual{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={hargaJual}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setHargaJual(tempValue);
                            setHargaNetto(tempValue);

                            setDiscountPersen("0")
                            setDiscount("0")

                            let tempTotalPenjualanChild =
                              parseFloat(quantity) * parseFloat(tempValue);
                            setTotalPenjualanChild(tempTotalPenjualanChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Disc.{" "}
                        {isInputStok === true ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="3">
                        <NumericFormat
                          required
                          value={discountPersen}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values, sourceInfo) => {
                            if (sourceInfo.source !== "event") return;

                            let tempValue = values.formattedValue;
                            setDiscountPersen(tempValue);

                            let tempDiscount =
                              (parseFloat(hargaJual) * tempValue) / 100;
                            setDiscount(tempDiscount);

                            let temHargaNetto =
                              parseFloat(hargaJual) - parseFloat(tempDiscount);
                            setHargaNetto(temHargaNetto);

                            let tempTotalPenjualanChild =
                              parseFloat(quantity) * parseFloat(temHargaNetto);
                            setTotalPenjualanChild(tempTotalPenjualanChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                      <Col sm="4">
                        <NumericFormat
                          required
                          value={discount}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values, sourceInfo) => {
                            if (sourceInfo.source !== "event") return;
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setDiscount(tempValue);

                            let tempDiscountPersen =
                              (parseFloat(tempValue) / parseFloat(hargaJual)) *
                              100;
                            // limit to 2 decimals
                            tempDiscountPersen = Number(
                              tempDiscountPersen.toFixed(2)
                            );
                            setDiscountPersen(tempDiscountPersen);

                            let temHargaNetto =
                              parseFloat(hargaJual) - parseFloat(tempValue);
                            setHargaNetto(temHargaNetto);

                            let tempTotalPenjualanChild =
                              parseFloat(quantity) * parseFloat(temHargaNetto);
                            setTotalPenjualanChild(tempTotalPenjualanChild);
                          }}
                          disabled={isInputStok === true ? false : true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Harga Netto :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={hargaNetto}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={totalPenjualanChild}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}></Box>
            </Box>

            <Box sx={spacingTop}>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
                disabled={isInputStok === true ? false : true}
              >
                Simpan Transaksi
              </Button>
            </Box>
          </Card.Body>
        </Card>
      </Form>

      <Box sx={tableChildWrapper}>
        <ShowTablePenjualanChildSaved currentPosts={penjualanChilds} />
      </Box>

      <Form noValidate validated={validated} onSubmit={savePenjualanTotal}>
        <Card style={{ marginTop: 10 }}>
          <Card.Header>Data Total</Card.Header>
          <Card.Body>
            <Box sx={textFieldContainer}>
              <Box sx={textFieldWrapper}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Subtotal :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={subtotal}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Potongan :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={potongan}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setPotongan(tempValue);

                            let tempTotal =
                              parseFloat(subtotal) -
                              parseFloat(tempValue) +
                              parseFloat(totalBiaya);
                            setTotal(tempTotal);

                            setBayar("0");
                            setKembali("0");
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Jenis Pembayaran <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <Autocomplete
                          size="small"
                          disablePortal
                          id="combo-box-demo"
                          options={jenisPembayaranOptions}
                          renderInput={(params) => (
                            <TextField
                              error={
                                error &&
                                kodeJenisPembayaran.length === 0 &&
                                true
                              }
                              size="small"
                              {...params}
                            />
                          )}
                          onChange={(e, value) => {
                            if (value) {
                              setKodeJenisPembayaran(value.label);
                              setBiayaJenisPembayaran(
                                value.biayaJenisPembayaran
                              );

                              let tempTotalBiaya =
                                (parseFloat(subtotal) *
                                  parseFloat(value.biayaJenisPembayaran)) /
                                100;
                              setTotalBiaya(tempTotalBiaya);

                              let tempTotal =
                                parseFloat(subtotal) -
                                parseFloat(potongan) +
                                parseFloat(tempTotalBiaya);
                              setTotal(tempTotal);

                              if (value.label !== "1 - TUNAI") {
                                setBayar(tempTotal);
                              }

                              let tempKembali =
                                parseFloat(bayar) - parseFloat(tempTotal);
                              setKembali(tempKembali);
                            } else {
                              setKodeJenisPembayaran("");
                            }
                          }}
                          value={kodeJenisPembayaran}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Biaya :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={totalBiaya}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Total :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={total}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Bayar <b style={colorRed}>*</b> :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          required
                          value={bayar}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setBayar(tempValue);

                            let tempKembali =
                              parseFloat(tempValue) - parseFloat(total);
                            setKembali(tempKembali);
                          }}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Kembali :
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          disabled
                          value={kembali}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
              <Box sx={[textFieldWrapper, secondWrapper]}>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tipe Penjualan <b style={colorRed}>*</b> :
                        {/* {isGrosir === "GROSIR" ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )} */}
                      </Form.Label>
                      <Col sm="7">
                        <Form.Select
                          required
                          value={tipePenjualan}
                          onChange={(e) => {
                            setTipePenjualan(e.target.value);

                            if (e.target.value === "TUNAI") {
                              setLamaKredit("");
                              setTglJatuhTempo(null);
                            }
                          }}
                          // disabled={isGrosir === "GROSIR" ? false : true}
                        >
                          {tipePenjualanOption.map((tipePenjualan) => (
                            <option value={tipePenjualan}>
                              {tipePenjualan}
                            </option>
                          ))}
                        </Form.Select>
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Lama Kredit{" "}
                        {tipePenjualan === "KREDIT" ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <NumericFormat
                          value={lamaKredit}
                          decimalSeparator={","}
                          thousandSeparator={"."}
                          customInput={Form.Control}
                          onValueChange={(values) => {
                            let tempValue = values.formattedValue
                              .split(".")
                              .join("")
                              .replace(/,/g, "");
                            setLamaKredit(tempValue);

                            let tempTglJatuhTempo = addDays(
                              tglPenjualan,
                              parseInt(tempValue)
                            );
                            setTglJatuhTempo(tempTglJatuhTempo);
                          }}
                          disabled={tipePenjualan !== "KREDIT" && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Form.Group
                      as={Row}
                      className="mb-3"
                      controlId="formPlaintextPassword"
                    >
                      <Form.Label column sm="5" style={textRight}>
                        Tgl. Jatuh Tempo{" "}
                        {tipePenjualan === "KREDIT" ? (
                          <>
                            <b style={colorRed}>*</b>
                            {" :"}
                          </>
                        ) : (
                          ":"
                        )}
                      </Form.Label>
                      <Col sm="7">
                        <DatePicker
                          dateFormat="dd/MM/yyyy"
                          selected={tglJatuhTempo}
                          customInput={<Form.Control required />}
                          onChange={(date) => {
                            setTglJatuhTempo(date);

                            let tempLamaKredit = diffDays(tglPenjualan, date);
                            setLamaKredit(tempLamaKredit);
                          }}
                          disabled={tipePenjualan !== "KREDIT" && true}
                        />
                      </Col>
                    </Form.Group>
                  </Col>
                </Row>
              </Box>
            </Box>
          </Card.Body>
        </Card>

        <Box sx={spacingTop}>
          <Button
            variant="outlined"
            color="secondary"
            onClick={() => navigate("/daftarPenjualan")}
            sx={{ marginRight: 2 }}
          >
            {"< Kembali"}
          </Button>
          <Button
            variant="contained"
            startIcon={<SaveIcon />}
            type="submit"
            disabled={penjualanId === null && true}
          >
            Simpan
          </Button>
        </Box>
      </Form>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}

      <Dialog
        open={openCustomer}
        onClose={handleCloseCustomer}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Customer`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchData}>
              <Box sx={searchBarContainer}>
                <SearchBar value={query} setSearchTerm={setQuery} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      No. Polisi
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      No. Telepon
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {customers.map((customer, index) => (
                    <TableRow
                      key={customer._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        if (customer.nopolCustomer !== "TUNAI") {
                          setNopolCustomer(customer.nopolCustomer);
                          setNamaCustomer(customer.namaCustomer);
                          setNoTeleponCustomer(customer.noTeleponCustomer);
                          setIsCustomerChosen(true);
                          setIsCustomerTunaiChosen(false);
                          setIsCustomerBaru(false);
                        } else {
                          setNopolCustomer(customer.nopolCustomer);
                          setNamaCustomer(customer.namaCustomer);
                          setNoTeleponCustomer("");
                          setIsCustomerChosen(true);
                          setIsCustomerTunaiChosen(true);
                          setIsCustomerBaru(false);
                        }
                        handleCloseCustomer();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {customer.nopolCustomer}
                      </TableCell>
                      <TableCell>{customer.namaCustomer}</TableCell>
                      <TableCell>{customer.noTeleponCustomer}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pages}
                page={page + 1}
                onChange={handleChange}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openStok}
        onClose={handleCloseStok}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{`Pilih Data Stok`}</DialogTitle>
        <DialogActions>
          <Box sx={dialogContainer}>
            <Form onSubmit={searchDataStok}>
              <Box sx={searchBarContainer}>
                <SearchBar value={queryStok} setSearchTerm={setQueryStok} />
                <Button
                  variant="contained"
                  type="submit"
                  color="primary"
                  disableElevation
                >
                  Cari
                </Button>
              </Box>
            </Form>
            <TableContainer component={Paper} sx={dialogWrapper}>
              <Table aria-label="simple table">
                <TableHead className={classes.root}>
                  <TableRow>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Kode
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Nama
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Satuan
                    </TableCell>
                    <TableCell
                      sx={{ fontWeight: "bold" }}
                      className={classes.tableRightBorder}
                    >
                      Sisa
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {stoks.map((stok, index) => (
                    <TableRow
                      key={stok._id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                        "&:hover": { bgcolor: Colors.grey300 },
                        cursor: "pointer",
                      }}
                      onClick={async () => {
                        setPilihStok(stok.kodeStok);
                        setKodeStok(stok.kodeStok);
                        setNamaStok(stok.namaStok);
                        setHargaJual(stok.hargaJualStok);
                        setHargaJualRataRataStok(
                          stok.hargaJualRataRataStok || 0
                        );
                        setHargaNetto(stok.hargaJualStok);
                        setTotalPenjualanChild(stok.hargaJualStok);

                        handleCloseStok();
                      }}
                    >
                      <TableCell component="th" scope="row">
                        {stok.kodeStok}
                      </TableCell>
                      <TableCell>{stok.namaStok}</TableCell>
                      <TableCell>{stok.satuanKecilStok}</TableCell>
                      <TableCell>-</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <Box sx={tableContainer}>
              <Pagination
                count={pagesStok}
                page={pageStok + 1}
                onChange={handleChangeStok}
                color="primary"
                size={screenSize <= 600 ? "small" : "large"}
              />
            </Box>
          </Box>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TambahPenjualan;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const dialogContainer = {
  display: "flex",
  flexDirection: "column",
  width: "800px",
};

const dialogWrapper = {
  width: "100%",
  marginTop: 2,
};

const colorRed = {
  color: "red",
};

const tableContainer = {
  pt: 4,
  display: "flex",
  justifyContent: "center",
};

const searchBarContainer = {
  pt: 6,
  display: "flex",
  justifyContent: "center",
};

const textFieldContainer = {
  display: "flex",
  flexDirection: {
    xs: "column",
    sm: "row",
  },
};

const textFieldWrapper = {
  display: "flex",
  flex: 1,
  flexDirection: "column",
  maxWidth: {
    md: "40vw",
  },
};

const secondWrapper = {
  marginLeft: {
    sm: 4,
  },
  marginTop: {
    sm: 0,
    xs: 4,
  },
};

const tableChildWrapper = {
  mt: 4,
  height: "400px",
  overflowY: "auto",
  border: "1px solid #e0e0e0",
};
